import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { LoginService } from './login.service';

export interface ActivityDirectory {
  users: { id: string; name: string; email: string; lastSignInAt: number | null; mandantIds: string[] }[];
  mandants: { id: string; name: string }[];
  tiles: { id: string; name: string; ownerMandantId: string | null; mandantIds: string[] }[];
}
export interface ActivityFilters {
  from: string;
  to: string;
  mandantId: string;
  userId: string;
  tileId: string;
  kind: string;
  eventPage: number;
  clusterPage: number;
}
export interface ActivityReport {
  startedAt: string | null;
  retentionDays: number;
  pageSize: number;
  totals: { events: number; visits: number; opens: number; users: number; mandants: number };
  daily: { _id: string; visits: number; opens: number }[];
  byMandant: { _id: string | null; count: number }[];
  byTile: { _id: string; count: number }[];
  clusters: { _id: { mandantId: string | null; userId: string; tileId: string }; count: number; lastAt: string }[];
  clusterTotal: number;
  events: { _id: string; at: string; kind: 'portal_visit' | 'tile_open'; userId: string; mandantId: string | null; tileId: string | null }[];
}

@Injectable({ providedIn: 'root' })
export class ActivityService {
  constructor(private http: HttpClient, private login: LoginService) {}

  async directory(): Promise<ActivityDirectory> {
    return firstValueFrom(this.http.get<ActivityDirectory>('/api/activity/directory'));
  }

  async report(filters: ActivityFilters): Promise<ActivityReport> {
    let params = new HttpParams();
    for (const [key, value] of Object.entries(filters)) {
      if (value !== '') params = params.set(key, value);
    }
    return firstValueFrom(this.http.get<ActivityReport>('/api/activity/report', { params }));
  }

  record(kind: 'portal_visit' | 'tile_open', tileId?: string): void {
    const authorization = this.login.getAuthorizationToken();
    if (!authorization) return;
    // Keep native anchor behavior (including middle-click and same-tab navigation)
    // while allowing the small tracking request to finish after leaving the portal.
    void fetch('/api/activity/events', {
      method: 'POST', keepalive: true, credentials: 'same-origin',
      headers: { Authorization: authorization, 'Content-Type': 'application/json' },
      body: JSON.stringify(kind === 'tile_open' ? { kind, tileId } : { kind }),
    }).then(response => {
      if (!response.ok) throw new Error(`Activity recording failed (${response.status})`);
    }).catch(error => console.error('Portal activity could not be recorded', error));
  }
}
